import { ChevronsLeftIcon, ChevronsRightIcon } from "lucide-react";
import { FC } from "react";
import { useSkyViewStore } from "~/features/skyView/store";

type ExpandableControlProps = {};

export const ExpandableControl: FC<ExpandableControlProps> = () => {
  const { isExpanded, toggleExpanded } = useSkyViewStore();

  return (
    <div
      className={
        "w-3 h-screen relative border-r border-l border-gray-100 flex items-center justify-center cursor-pointer hover:bg-gray-50"
      }
      onClick={toggleExpanded}
    >
      {isExpanded ? (
        <ChevronsRightIcon className="w-2 h-2" />
      ) : (
        <ChevronsLeftIcon className="w-2 h-2" />
      )}
    </div>
  );
};
